import {
  TComponentValue,
} from '@/types/openapi-type.ts';

type TNextState = Exclude<TComponentValue<'MaintenanceState'>, 'PENDING' | 'REJECTED'>;
type TPrevState = Exclude<TComponentValue<'MaintenanceState'>, 'COMPLETED' | 'IN_REVIEW'>;
type TStageChangeButtons = {
  next: Record<TNextState, string>,
  previous: Record<TPrevState, string>,
};

const stateChangeButtons: TStageChangeButtons = {
  next: {
    // PENDING -> ASSIGNED
    ASSIGNED: 'Aufgabe annehmen',
    // ASSIGNED -> IN_PROGRESS
    IN_PROGRESS: 'Arbeit starten',
    // IN_PROGRESS -> IN_REVIEW
    IN_REVIEW: 'Arbeit abschließen',
    // IN_REVIEW -> COMPLETED
    COMPLETED: 'Akzeptieren',
  },
  previous: {
    // ASSIGNED -> PENDING
    PENDING: 'Aufgabe ablehnen',
    // IN_PROGRESS -> ASSIGNED
    ASSIGNED: 'Arbeit abbrechen',
    // IN_REVIEW -> IN_PROGRESS
    IN_PROGRESS: 'Erneut vorlegen',
    // IN_REVIEW -> REJECTED
    REJECTED: 'Erneut vorlegen',
  },
};

export default {
  stateChangeButtons,
};
